import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  position: relative;
`;

const Box = styled.div`
  padding: 20px;
`;
const WizardFooter = styled.div`
  height: 30px;
  background-color: rgb(32, 144, 136);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
  color: white !important;
`;

const Img = styled.img`
  width: 8px;
  height: 15px;
  margin-right: 10px;
`;
const Link = styled.button`
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  margin-top: 15px;
  border: none;
  margin-top: 80px;
  margin-bottom: 0;
  outline-style: none;
  position: absolute;
  top: -65px;
  right: 40px;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;

const WizardContent = styled.div`
  height: 80%;
  width: 100%;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  form {
    width: 100%;
    display: flex;
    padding-top: 0px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
`;

export { Container, Box, WizardFooter, Img, WizardContent, Link };
